<template>
  <ul class="list" :class="{'list--visible': visible}">
    <router-link tag="li" to="/add/invoice">Utwórz fakturę</router-link>
    <router-link tag="li" to="/add/warehouse-doc">Utwórz dokument magazynowy</router-link>
    <!-- <router-link tag="li" to="/scan">Skanuj dokument</router-link> -->
  </ul>
</template>

<script>
export default {
  name: "add-list",
  props: {
    visible: Boolean
  }
}
</script>

<style lang="scss" scoped>
  .list {
    bottom: 84px;
    right: -32px;
    position: fixed;
    background-color: #fff;
    border-radius: 4px;
    padding: 8px;
    opacity: 0;
    visibility: hidden;
    transition: 0.3s;
    list-style: none;
    box-shadow: 2px 2px 8px rgba($primaryColor, 0.5);

    li {
      color: #888;
      padding: 6px 12px;
      cursor: pointer;
      transition: 0.3s;

      &:hover {
        color: $primaryColor;
      }
    }

    &--visible {
      opacity: 1;
      visibility: visible;
      bottom: 84px;
      right: 48px;
    }
  }
</style>
